const f = (id, v) => `${id}${String(v.length).padStart(2, "0")}${v}`;

const clean = (s, max) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9 ]/g, "").toUpperCase().slice(0, max).trim();

const crc16 = (str) => {
  let crc = 0xffff;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
};

export const buildPix = ({ key, name, city, amount, txid }) => {
  const mai = f("00", "br.gov.bcb.pix") + f("01", key.trim());
  const tx = (txid || "***").replace(/[^A-Za-z0-9]/g, "").slice(0, 25) || "***";
  const payload =
    f("00", "01") + f("26", mai) + f("52", "0000") + f("53", "986") +
    (amount ? f("54", Number(amount).toFixed(2)) : "") +
    f("58", "BR") + f("59", clean(name, 25) || "LOJA") + f("60", clean(city, 15) || "SAO PAULO") +
    f("62", f("05", tx)) + "6304";
  return payload + crc16(payload);
};
